export { default as SuggestQuery } from './SuggestQuery';